<template>
  <div>
    <div id="show-overlay"></div>
    <Loader />
    <div class="wrapper">
      <!-- Sidebar  -->
      <SideBarStyle1
        :items="verticalMenu"
        :horizontal="horizontal"
        @toggle="sidebarMini"
      />
      <!-- TOP Nav Bar -->
      <NavBarStyle1
        title="Dashboard"
        :homeURL="{ name: 'dashboard1.home' }"
        @toggle="sidebarMini"
        :logo="logo"
        :horizontal="horizontal"
        :items="horizontalMenu"
      >
        <template slot="responsiveRight">
          <ul class="navbar-nav ml-auto navbar-list">
            <!-- <li class="nav-item nav-icon">
              <a
                href="#"
                class="search-toggle iq-waves-effect bg-primary rounded"
              >
                <i class="ri-notification-line"></i>
                <span class="bg-danger dots"></span>
              </a>
              <div class="iq-sub-dropdown">
                <div class="iq-card shadow-none m-0">
                  <div class="iq-card-body p-0">
                    <div class="bg-primary p-3">
                      <h5 class="mb-0 text-white">
                        {{ $t('nav.allNotifications') }}
                        <small class="badge badge-light float-right pt-1"
                          >4</small
                        >
                      </h5>
                    </div>
                    <a
                      href="#"
                      class="iq-sub-card"
                      v-for="(item, index) in notification"
                      :key="index"
                    >
                      <div class="media align-items-center">
                        <div class>
                          <img
                            class="avatar-40 rounded"
                            :src="item.image"
                            alt="img"
                          />
                        </div>
                        <div class="media-body ml-3">
                          <h6 class="mb-0">{{ item.name }}</h6>
                          <small class="float-right font-size-12">
                            {{ item.date }}
                          </small>
                          <p class="mb-0">
                            {{ item.description.substring(0, 40) + '...' }}
                          </p>
                        </div>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </li> -->
            <li class="nav-item nav-icon">
              <a
                href="#"
                class="search-toggle iq-waves-effect bg-primary rounded"
              >
                <i class="ri-mail-line"></i>
                <span class="bg-primary count-mail"></span>
              </a>

              <!-- email notification -->
              <appNewEmailNotificationDropdownList></appNewEmailNotificationDropdownList>
              <!-- <div class="iq-sub-dropdown">
                <div class="iq-card shadow-none m-0">
                  <div class="iq-card-body p-0">
                    <div class="bg-primary p-3">
                      <h5 class="mb-0 text-white">
                        {{ $t('nav.allMessages') }}
                        <small class="badge badge-light float-right pt-1"
                          >51111</small
                        >
                      </h5>
                    </div>
                    <a
                      href="#"
                      class="iq-sub-card"
                      v-for="(item, index) in message"
                      :key="index"
                    >
                      <div class="media align-items-center">
                        <div class>
                          <img
                            class="avatar-40 rounded"
                            :src="item.image"
                            alt="img"
                          />
                        </div>
                        <div class="media-body ml-3">
                          <h6 class="mb-0">{{ item.name }}</h6>
                          <small class="float-left font-size-12">
                            {{ item.date }}
                          </small>
                        </div>
                      </div>
                    </a>
                  </div>
                </div>
              </div> -->
            </li>
          </ul>
        </template>
        <template slot="right">
          <ul class="navbar-list">
            <li>
              <a
                href="#"
                class="search-toggle iq-waves-effect d-flex align-items-center"
              >
                <img
                  v-if="userObj.profileImage"
                  :src="userObj.profileImage"
                  class="img-fluid rounded border mr-3 mt-2"
                  alt="user"
                />
                <span v-else class="img-fluid rounded mr-3 mt-1 avatar-default"
                  ><i class="las la-user-alt fs-3000"></i
                ></span>
                <div class="caption">
                  <h6 class="mb-0 line-height">{{ userObj.firstName }}</h6>
                  <span class="font-size-12">
                    <!-- {{ dealerObj.name }} -->
                  </span>
                </div>
              </a>
              <div class="iq-sub-dropdown iq-user-dropdown">
                <div class="iq-card shadow-none m-0">
                  <div class="iq-card-body p-0">
                    <div class="bg-primary p-3">
                      <h5 class="mb-0 text-white line-height">
                        Hello {{ userObj.firstName }}
                      </h5>
                      <span class="text-white font-size-12">
                        <!-- {{ dealerObj.name }} -->
                      </span>
                    </div>
                    <router-link
                      to="/bdm/profile"
                      class="iq-sub-card iq-bg-primary-hover"
                    >
                      <div class="media align-items-center">
                        <div class="rounded iq-card-icon iq-bg-primary">
                          <i class="ri-file-user-line"></i>
                        </div>
                        <div class="media-body ml-3">
                          <h6 class="mb-0">
                            {{ $t('nav.user.profileTitle') }}
                          </h6>
                          <p class="mb-0 font-size-12">
                            {{ $t('nav.user.profileSub') }}
                          </p>
                        </div>
                      </div>
                    </router-link>
                    <router-link
                      to="/bdm/password-change"
                      class="iq-sub-card iq-bg-primary-danger-hover"
                    >
                      <div class="media align-items-center">
                        <div class="rounded iq-card-icon iq-bg-danger">
                          <i class="ri-account-box-line"></i>
                        </div>
                        <div class="media-body ml-3">
                          <h6 class="mb-0">
                            {{ $t('nav.user.accountSettingTitle') }}
                          </h6>
                          <p class="mb-0 font-size-12">Change password</p>
                        </div>
                      </div>
                    </router-link>
                    <div class="d-inline-block w-100 text-center p-3">
                      <a
                        class="iq-bg-danger iq-sign-btn"
                        href="javascript:void(0)"
                        @click="logout"
                        role="button"
                      >
                        {{ $t('nav.user.signout') }}
                        <i class="ri-login-box-line ml-2"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </template>
      </NavBarStyle1>
      <!-- TOP Nav Bar END -->
      <div
        id="content-page"
        class="content-page"
        :class="horizontal ? 'ml-0' : ''"
      >
        <transition
          name="router-anim"
          :enter-active-class="`animated ${animated.enter}`"
          mode="out-in"
          :leave-active-class="`animated ${animated.exit}`"
        >
          <router-view />
        </transition>
      </div>
    </div>
    <FooterStyle1>
      <template v-slot:left>
        <li class="list-inline-item mr-5">
          <a>All Rights Reserved for VSA</a>
        </li>
        <li class="list-inline-item mr-3">
          <router-link to="/bdm/privacy-policy">Privacy Policy</router-link>
        </li>
        <li class="list-inline-item mr-3">
          <router-link to="/bdm/terms-of-use">Terms of Use</router-link>
        </li>
      </template>
      <template v-slot:right>
        Developed by: <a href="http://samath.com.au">Samath IT Solutions</a>.
      </template>
    </FooterStyle1>
  </div>
</template>
<script>
import Loader from '../components/findash/loader/Loader'
import SideBarStyle1 from '../components/findash/sidebars/SideBarStyle1'
import NavBarStyle1 from '../components/findash/navbars/NavBarStyle1'
import SideBarItems from '../FackApi/json/SideBarBDM'
import HorizontalItems from '../FackApi/json/HorizontalMenu'
import loader from '../assets/images/loader.gif'
import darkLoader from '../assets/images/darkMode/dark-logo.gif'
import { findash } from '../config/pluginInit'
import { Users } from '../FackApi/api/chat'
import { mapGetters, mapActions } from 'vuex'
import * as authService from '../services/auth.service'
import appNewEmailNotificationDropdownList from '../components/partials/NewEmailNotificationDropdownList.vue'

let body = document.querySelector('body')
export default {
  name: 'LayoutBdm',
  components: {
    Loader,
    SideBarStyle1,
    NavBarStyle1,
    appNewEmailNotificationDropdownList
  },
  mounted() {
    this.updateRadio()
    body.classList.remove('sidebar-main-active')
    body.classList.remove('right-column-fixed')
    if (this.$route.meta.dark) {
      body.classList.add('dark')
      body.classList.remove('light')
      this.logo = darkLoader
    } else {
      body.classList.add('light')
      body.classList.remove('dark')
      this.logo = loader
    }
  },
  computed: {
    ...mapGetters({
      cartCount: 'Ecommerce/cartCountState',
      cartItems: 'Ecommerce/cartState',
      selectedLang: 'Setting/langState',
      langsOptions: 'Setting/langOptionState',
      darkMode: 'Setting/darkModeState',
      colors: 'Setting/colorState',
      getIsUserSettingUpdate: 'getIsUserSettingUpdate'
    })
  },
  // sidebarTicket
  data() {
    return {
      userObj: {},
      dealerObj: {},
      horizontal: false,
      mini: false,
      animated: { enter: 'zoomIn', exit: 'zoomOut' },
      animateClass: [
        { value: { enter: 'zoomIn', exit: 'zoomOut' }, text: 'Zoom' },
        { value: { enter: 'fadeInUp', exit: 'fadeOutDown' }, text: 'Fade' },
        {
          value: { enter: 'slideInLeft', exit: 'slideOutRight' },
          text: 'Slide'
        },
        {
          value: { enter: 'rotateInDownLeft', exit: 'rotateOutDownLeft' },
          text: 'Roll'
        }
      ],
      horizontalMenu: HorizontalItems,
      verticalMenu: this.verticalMenuNew,
      logo: loader,
      usersList: Users,
      rtl: false,
      message: [
        {
          image: require('../assets/images/user/user-01.jpg'),
          name: 'Nik Emma Watson',
          date: '13 jan'
        },
        {
          image: require('../assets/images/user/user-02.jpg'),
          name: 'Greta Life',
          date: '14 Jun'
        },
        {
          image: require('../assets/images/user/user-03.jpg'),
          name: 'Barb Ackue',
          date: '16 Aug'
        },
        {
          image: require('../assets/images/user/user-04.jpg'),
          name: 'Anna Sthesia',
          date: '21 Sept'
        },
        {
          image: require('../assets/images/user/user-05.jpg'),
          name: 'Bob Frapples',
          date: '29 Sept'
        }
      ],
      notification: [
        {
          image: require('../assets/images/user/user-01.jpg'),
          name: 'Nik Emma Watson',
          date: '23 hour ago',
          description: 'Enjoy smart access to videos, games'
        },
        {
          image: require('../assets/images/user/user-02.jpg'),
          name: 'Greta Life',
          date: '14 hour ago',
          description: 'Google Chromecast: Enjoy a world of entertainment'
        },
        {
          image: require('../assets/images/user/user-03.jpg'),
          name: 'Barb Ackue',
          date: '16 hour ago',
          description: 'Dell Inspiron Laptop: Get speed and performance from'
        },
        {
          image: require('../assets/images/user/user-04.jpg'),
          name: 'Anna Sthesia',
          date: '21 hour ago',
          description: 'Deliver your favorite playlist anywhere in your home '
        },
        {
          image: require('../assets/images/user/user-05.jpg'),
          name: 'Bob Frapples',
          date: '11 hour ago',
          description:
            'MacBook Air features up to 8GB of memory, a fifth-generation'
        }
      ]
    }
  },
  methods: {
    logout: async function () {
      authService.logout()
      this.$router.push('/')
    },
    dark() {
      body.classList.remove('light')
      body.classList.add('dark')
      this.modeChange(true)
      this.logo = darkLoader
    },
    light() {
      body.classList.remove('dark')
      body.classList.add('light')
      this.modeChange(false)
      this.logo = loader
    },
    updateRadio() {
      this.horizontal = this.$store.getters['Setting/horizontalMenuState']
      this.mini = this.$store.getters['Setting/miniSidebarState']
    },
    sidebarHorizontal() {
      this.$store.dispatch('Setting/horizontalMenuAction')
      this.updateRadio()
    },
    sidebarMini() {
      findash.triggerSet()
      this.$store.dispatch('Setting/miniSidebarAction')
      this.updateRadio()
    },
    rtlChange(mode) {
      this.rtl = mode
      if (this.rtl) {
        this.rtlRemove()
      } else {
        this.rtlAdd()
      }
      if (this.darkMode) {
        body.classList.add('dark')
        body.classList.remove('light')
        this.logo = darkLoader
      } else {
        body.classList.add('light')
        body.classList.remove('dark')
        this.logo = loader
      }
    },
    changeColor(code) {
      document.documentElement.style.setProperty('--iq-primary', code.primary)
      document.documentElement.style.setProperty(
        '--iq-primary-light',
        code.primaryLight
      )
      if (this.darkMode) {
        document.documentElement.style.setProperty(
          '--iq-bg-dark-color',
          code.bodyBgDark
        )
      } else {
        document.documentElement.style.setProperty(
          '--iq-bg-light-color',
          code.bodyBgLight
        )
      }
    },
    reset() {
      this.changeColor({
        primary: '#827af3',
        primaryLight: '#b47af3',
        bodyBgLight: '#efeefd',
        bodyBgDark: '#1d203f'
      })
      this.animated = { enter: 'zoomIn', exit: 'zoomOut' }
      this.light()
    },

    langChange(lang) {
      this.langChangeState(lang)
      this.$i18n.locale = lang.value
      document.getElementsByClassName('iq-show')[0].classList.remove('iq-show')
      if (lang.value === 'ar') {
        this.rtlAdd(lang)
      } else {
        this.rtlRemove(lang)
      }
    },
    /**
     * Process (filter) side bar item according to user settings
     */
    // fnSideBarItems(SideBarItems) {
    //   const { accessMaturingLeases } =
    //     authService.getUserFromToken()?.settings || ''

    //   const newSideBarItem = SideBarItems.filter((item) => {
    //     if (accessMaturingLeases == null || accessMaturingLeases == undefined) {
    //       return item.name != 'Maturing Leases'
    //     }

    //     if (accessMaturingLeases == 'Y') {
    //       return item.name
    //     } else {
    //       return item.name != 'Maturing Leases'
    //     }
    //   })

    //   return newSideBarItem
    // },
    fnSideBarItems(SideBarItems) {
      const userSettings = authService.getUserFromToken()?.settings || []

      if (userSettings.length == 0) {
        return
      }

      if (SideBarItems.length == 0) {
        return
      }

      let newSideBarItem = []

      for (let settings of userSettings) {
        for (let menuItem of SideBarItems) {
          if (menuItem.name == settings) {
            newSideBarItem.push(menuItem)
          }
        }
      }

      let newSideBarItem1 = SideBarItems.filter((item) => {
        if (item.name == 'Dashboard') {
          return item
        }
      })

      newSideBarItem.concat(newSideBarItem1)

      return newSideBarItem
    },

    ...mapActions({
      removeToCart: 'Ecommerce/removeToCartAction',
      langChangeState: 'Setting/setLangAction',
      rtlAdd: 'Setting/setRtlAction',
      rtlRemove: 'Setting/removeRtlAction',
      modeChange: 'Setting/darkModeAction',
      fetchIsUserSettingUpdate: 'fetchIsUserSettingUpdate'
    })
  },
  async created() {
    this.userObj = await authService.getUserFromToken()
    this.verticalMenu = await this.fnSideBarItems(SideBarItems)
  },
  watch: {
    async getIsUserSettingUpdate(val) {
      this.verticalMenu = await this.fnSideBarItems(SideBarItems)
      this.userObj = await authService.getUserFromToken()
    }
  }
}
</script>
<style>
@import url('../assets/css/custom.css');
@import url('../assets/css/PriceSlider.css');
</style>
